import { Pages } from '../constants/pages';

export const checkProductManager = (pages: string[]) =>
  pages.some((page) => page === Pages.ProductManager || page === Pages.Settings);
